import { gql } from '@apollo/client';
import { textPairFragment } from '../../query/fragments';

/**
 * @name CONTACT_US_BLOCK_QUERY
 * @description GraphQL query to fetch global data for ContactUsBlock that can be cached across users
 * @public
 */
export const CONTACT_US_BLOCK_QUERY = gql`
  query ContactUsBlockQuery {
    textFor {
      chatEnabledLabelText: pair(pairKey: "chatEnabledLabel") {...textPair}
      chatDisabledLabelText: pair(pairKey: "chatDisabledLabel") {...textPair}
      phoneNumbersDesktopLabelText: pair(pairKey: "phoneNumbersDesktopLabel") {...textPair}
      callUsMobileLabelText: pair(pairKey: "callUsMobileLabel") {...textPair}
      textUsLabel: pair(pairKey: "textUsLabel") {...textPair}
      customerMessageNumber: pair(pairKey: "customerMessageNumber") {...textPair}
      phoneNumberModalLabel: pair(pairKey: "phoneNumberLabel") {...textPair}
    }
    config {
      customerCareIcons: string(name: "customerCareIcons")
      imageServiceUrl: string(name: "imageServiceUrl")
    }
  }
  ${textPairFragment}
`;

/**
 * @name CONTACT_US_BLOCK_FEATURE_FLAGS_QUERY
 * @description GraphQL query to fetch user-specific feature flags for ContactUsBlock that should not be cached across users
 * @public
 */
export const CONTACT_US_BLOCK_FEATURE_FLAGS_QUERY = gql`
  query ContactUsBlockFeatureFlagsQuery {
    emailUsModuleEnabled: featureFlag(
      key: "custcare-email-module-enabled",
      defaultValue: false
    )
    viewPhoneNumberModuleEnabled: featureFlag(
      key: "custcare-call-module-enabled",
      defaultValue: false
    )
    whatsAppModuleEnabled: featureFlag(
      key: "custcare-whatsapp-module-enabled",
      defaultValue: false
    )
  }
`;
